import React from "react";
import ModalBasic from "../../component/ModalBasic";

import InputText from "../../../components/inputs/InputText";

function LoginToCorporateSubscription(props) {
  return (
      <>
      <ModalBasic
        id="show-super-profile-modal"
        modalOpen={props.setAdminLoginToCorporateSubscription}
        setModalOpen={props.setOpenModal}
        title="login"
        >
        <div className="2xl:m-12 lg:m-5 m-0 ">
          <div className="">
            <label className="text-[#757575] xl:text-xl font-bold inline-block pb-4">
              Email
              <span className="text-[#C00000]">*</span>
            </label>
            <InputText
              placeholder=""
              type="text"
              name="userName"
              value={props.corporateSubscriptionDetailsForLogin.userName}
              handleChange={props.handleChangeForLoginInCorporateSubscription}
            // validateField={() => props.validateField("name", props.contributionDetails)}
            />
            {/* <ValidationText error={props.validState.error.name} /> */}
          </div>
          <div className="pt-8">
            <label className="text-[#757575] xl:text-xl font-bold inline-block pb-4">
              Password
              <span className="text-[#C00000]">*</span>
            </label>

            <input
              className="w-full custom-input"
              type="password"
              name="password"
              value={props.corporateSubscriptionDetailsForLogin.password}
              onChange={(e) => props.handleChangeForLoginInCorporateSubscription(e)}
            ></input>
          </div>

          <div className="flex justify-center pt-8">
            <button
              className="py-5 btn-red text-white text-xl font bold w-full"
            onClick={() => props.onSubmit()}
            >
              Login
            </button>
          </div>
        </div>
      </ModalBasic>
    </>
  );
}

export default LoginToCorporateSubscription;
